"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
var classnames_1 = __importDefault(require("classnames"));
var Models_1 = require("ContentTokens/Models");
var ContextualTextStyle_1 = __importDefault(require("DreamCoat/Contextual/ContextualTextStyle/ContextualTextStyle"));
var lodash_1 = __importDefault(require("lodash"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var react_addons_css_transition_group_1 = __importDefault(require("react-addons-css-transition-group"));
var slate_1 = require("slate");
var slate_react_1 = require("slate-react");
var EventUtils_1 = require("Utils/EventUtils");
var EditorTypes_1 = require("../EditorTypes");
var Utils_1 = require("../Utils");
var WidgetManager_1 = require("../WidgetManager");
var Toolbar = (function (_super) {
    __extends(Toolbar, _super);
    function Toolbar(props) {
        var _this = _super.call(this, props) || this;
        _this.blockTypeMap = {
            heading1: commonTypes_1.TextElementType.H1,
            heading2: commonTypes_1.TextElementType.H2,
            paragraph: commonTypes_1.TextElementType.P,
            blockQuote: commonTypes_1.TextElementType.Blockquote,
        };
        _this.BUTTON_WIDTH = 45;
        _this.styleMenuElem = null;
        _this.toolbarElem = null;
        _this.contextualStylesClicked = false;
        _this.contextualStylesUnclicked = function (event) {
            var notContextualClicked = _this.styleMenuElem &&
                !_this.styleMenuElem.contains(event.target) &&
                !(_this.styleMenuElem == event.target);
            if (notContextualClicked) {
                _this.contextualStylesClicked = false;
            }
            else {
                if (!_this.contextualStylesClicked) {
                    _this.contextualStylesClicked = true;
                }
            }
        };
        _this.reselectText = function (event) {
            if (document.activeElement.type == "text") {
                return;
            }
            var eventData = { eventType: "reselection", selection: _this.lastNonNullSelection };
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("toolbar", eventData));
        };
        _this.updateToolbarPosition = function () {
            if (_this.shouldHideToolbar) {
                if (!_this.toolbarHidden) {
                    _this.updateToolbarHidden(true);
                    _this.hideToolbar();
                }
            }
            else {
                _this.updateSelectionBlockType();
                _this.updateToolbarHidden(false);
                _this.setToolbarPosition();
            }
        };
        _this.updateLastNonNullSelection = function () {
            var currentSelection = _this.props.currentSelection;
            if (currentSelection !== null) {
                _this.lastNonNullSelection = currentSelection;
            }
        };
        _this.setToolbarPosition = function () {
            if (!_this.props.dontPosition && !!_this.props.widgetManager.editor.selection) {
                try {
                    var selection = _this.props.widgetManager.editor.selection;
                    var nativeRange_1 = slate_react_1.ReactEditor.toDOMRange(_this.props.widgetManager.editor, selection);
                    var rect = nativeRange_1.getBoundingClientRect();
                    if (!rect.left && !rect.top && _this.mostRecentNativeSelection) {
                        rect = _this.mostRecentNativeSelection.getBoundingClientRect();
                    }
                    else {
                        (0, mobx_1.runInAction)(function () {
                            _this.mostRecentNativeSelection = nativeRange_1;
                        });
                    }
                    if (!_this.toolbarElem) {
                        throw new Error("Could not find toolbar element");
                    }
                    if (!_this.styleMenuElem) {
                        throw new Error("Could not find style menu element");
                    }
                    var container = getBoundingClientRect(_this.props.editorElem);
                    var top = "".concat(rect.top - container.top - _this.toolbarElem.offsetHeight - 8, "px");
                    var left = "".concat(rect.left - container.left - _this.toolbarElem.offsetWidth / 2 + rect.width / 2, "px");
                    _this.toolbarElem.style.position = "absolute";
                    _this.toolbarElem.style.opacity = "1";
                    _this.toolbarElem.style.top = top;
                    _this.toolbarElem.style.left = left;
                    var rightPosition = -_this.styleMenuElem.offsetWidth / 2 + _this.BUTTON_WIDTH / 2;
                    _this.styleMenuElem.style.right = "".concat(rightPosition, "px");
                }
                catch (e) {
                    _this.hideToolbar();
                }
            }
            document.addEventListener("mousedown", _this.contextualStylesUnclicked);
        };
        _this.handleContextualStylesShowChange = function (newValue) {
            _this.contextualStylesShowing = newValue;
        };
        _this.selectedElementTypes = [commonTypes_1.TextElementType.H1];
        _this.contextualStylesShowing = false;
        _this.toolbarHidden = true;
        _this.mostRecentNativeSelection = null;
        return _this;
    }
    Toolbar.prototype.componentDidMount = function () {
        this.updateToolbarPosition();
        this.updateLastNonNullSelection();
    };
    Toolbar.prototype.componentWillUnmount = function () {
        document.removeEventListener("mousedown", this.contextualStylesUnclicked);
    };
    Toolbar.prototype.componentDidUpdate = function () {
        this.updateToolbarPosition();
        this.updateLastNonNullSelection();
    };
    Toolbar.prototype.render = function () {
        var _a;
        var _this = this;
        var widgetManager = this.props.widgetManager;
        if (!widgetManager.canEdit) {
            return null;
        }
        var _b = this.props, brandStore = _b.brandStore, blockStore = _b.blockStore, telemetry = _b.telemetry, dontPosition = _b.dontPosition;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)("editor-main-toolbar", (_a = {},
                _a["editor-main-toolbar--positioning"] = !dontPosition,
                _a)), ref: function (ref) {
                _this.toolbarElem = ref;
            } },
            react_1.default.createElement("div", { className: "editor-toolbar" }, this.renderButtons()),
            react_1.default.createElement("div", { className: "contextual-styles", ref: function (ref) {
                    _this.styleMenuElem = ref;
                }, onMouseUp: this.reselectText, style: this.contextualStylesShowing ? {} : { display: "none" } },
                react_1.default.createElement(react_addons_css_transition_group_1.default, { transitionName: "fade", transitionEnterTimeout: 150, transitionLeaveTimeout: 150 }, this.contextualStylesShowing && (react_1.default.createElement(ContextualTextStyle_1.default, { blockStore: blockStore, brandStore: brandStore, elementTypes: this.selectedElementTypes, updateToolbarPosition: this.updateToolbarPosition, telemetry: telemetry, reselectText: this.reselectText }))))));
    };
    Toolbar.prototype.renderButtons = function () {
        var buttons = this.getToolbarButtons(this.props.widgetManager.editor);
        return react_1.default.createElement("span", { className: "editor-main-toolbar__actions center-aligned" }, buttons);
    };
    Toolbar.prototype.updateToolbarHidden = function (isHidden) {
        if (!this.toolbarHidden == isHidden) {
            this.toolbarHidden = isHidden;
        }
    };
    Toolbar.prototype.updateSelectionBlockType = function () {
        var e_1, _a;
        var editor = this.props.widgetManager.editor;
        if (editor.selection === null) {
            return;
        }
        var types = [];
        var selectedBlocks = (0, Utils_1.getSelectedBlocks)(editor);
        try {
            for (var selectedBlocks_1 = __values(selectedBlocks), selectedBlocks_1_1 = selectedBlocks_1.next(); !selectedBlocks_1_1.done; selectedBlocks_1_1 = selectedBlocks_1.next()) {
                var blockEntry = selectedBlocks_1_1.value;
                var block = blockEntry[0];
                if (block.type !== EditorTypes_1.BlockType.ListItem) {
                    types.push(this.blockTypeMap[block.type] || commonTypes_1.TextElementType.P);
                }
                else {
                    if (block.data.listType === "bullet") {
                        types.push(commonTypes_1.TextElementType.UnorderedListItem);
                    }
                    else {
                        types.push(commonTypes_1.TextElementType.OrderedListItem);
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (selectedBlocks_1_1 && !selectedBlocks_1_1.done && (_a = selectedBlocks_1.return)) _a.call(selectedBlocks_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (types) {
            types = lodash_1.default.uniq(types).sort();
            var sameState = lodash_1.default.isEqual(this.selectedElementTypes, types);
            if (!sameState) {
                this.selectedElementTypes = types;
            }
        }
    };
    Toolbar.prototype.getToolbarButtons = function (editor) {
        var _this = this;
        var selection = this.props.widgetManager.editor.selection;
        if ((!selection || slate_1.Range.isCollapsed(selection) || !slate_react_1.ReactEditor.isFocused(this.props.widgetManager.editor)) &&
            !this.contextualStylesShowing) {
            return [];
        }
        var localisedConfiguration = this.props.config.filter(function (button) {
            var blockStore = _this.props.blockStore;
            if (blockStore.isSavedBlock && button.type === EditorTypes_1.MarkType.Comment) {
                return false;
            }
            if (insideTableCell(editor) && [EditorTypes_1.BlockType.BlockQuote, EditorTypes_1.MarkType.Style].includes(button.type)) {
                return false;
            }
            if ((0, Utils_1.isInsideAccordionHeading)(editor) &&
                [EditorTypes_1.BlockType.BlockQuote, EditorTypes_1.BlockType.ListItem, Models_1.InlineType.Link].includes(button.type)) {
                return false;
            }
            if ((0, Utils_1.isInsideAccordion)(editor) && button.type === EditorTypes_1.MarkType.Style) {
                return false;
            }
            return true;
        });
        return localisedConfiguration.map(function (button, index) { return (react_1.default.createElement(MainEditorToolbarButton, { key: index, button: button, contextualStylesShowing: _this.contextualStylesShowing, onContextualStylesShowingChange: _this.handleContextualStylesShowChange, onToolbarEvent: function (eventData) { return _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("toolbar", eventData)); }, editor: editor })); });
    };
    Object.defineProperty(Toolbar.prototype, "shouldHideToolbar", {
        get: function () {
            var editor = this.props.widgetManager.editor;
            var selection = editor.selection;
            if (this.contextualStylesShowing && this.contextualStylesClicked) {
                return false;
            }
            if (!selection || slate_1.Range.isCollapsed(selection) || !slate_react_1.ReactEditor.isFocused(editor)) {
                return true;
            }
            var changeable = [
                EditorTypes_1.BlockType.Paragraph,
                EditorTypes_1.BlockType.Heading1,
                EditorTypes_1.BlockType.Heading2,
                EditorTypes_1.BlockType.ListItem,
                EditorTypes_1.BlockType.BlockQuote,
            ];
            var selectedBlocks = (0, Utils_1.getSelectedBlocks)(editor);
            var hasNonChangeableBlocks = selectedBlocks.some(function (entry) { return !changeable.includes(entry[0].type); });
            var hasSelectedText = selectedBlocks.some(function (entry) { return slate_1.Node.string(entry[0]).length > 0; });
            var hideToolbar = !hasSelectedText || hasNonChangeableBlocks || aTableIsSelected(editor);
            return hideToolbar;
        },
        enumerable: false,
        configurable: true
    });
    Toolbar.prototype.hideToolbar = function () {
        this.contextualStylesShowing = false;
        if (this.toolbarElem) {
            this.toolbarElem.removeAttribute("style");
        }
        document.removeEventListener("mousedown", this.contextualStylesUnclicked);
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Array)
    ], Toolbar.prototype, "selectedElementTypes", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], Toolbar.prototype, "contextualStylesShowing", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], Toolbar.prototype, "toolbarHidden", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], Toolbar.prototype, "mostRecentNativeSelection", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], Toolbar.prototype, "contextualStylesClicked", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Toolbar.prototype, "contextualStylesUnclicked", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], Toolbar.prototype, "updateToolbarHidden", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Toolbar.prototype, "updateSelectionBlockType", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], Toolbar.prototype, "shouldHideToolbar", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Toolbar.prototype, "hideToolbar", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Toolbar.prototype, "handleContextualStylesShowChange", void 0);
    Toolbar = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], Toolbar);
    return Toolbar;
}(react_1.default.Component));
exports.default = Toolbar;
var aTableIsSelected = function (editor) {
    var e_2, _a;
    var selectedBlocks = (0, Utils_1.getSelectedBlocks)(editor);
    try {
        for (var selectedBlocks_2 = __values(selectedBlocks), selectedBlocks_2_1 = selectedBlocks_2.next(); !selectedBlocks_2_1.done; selectedBlocks_2_1 = selectedBlocks_2.next()) {
            var blockEntry = selectedBlocks_2_1.value;
            var block = blockEntry[0];
            if (block.type == EditorTypes_1.BlockType.Table) {
                return true;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (selectedBlocks_2_1 && !selectedBlocks_2_1.done && (_a = selectedBlocks_2.return)) _a.call(selectedBlocks_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return false;
};
var insideTableCell = function (editor) {
    if (!editor.selection) {
        return false;
    }
    return (0, Utils_1.hasAncestorOf)(editor, slate_1.Range.start(editor.selection).path, EditorTypes_1.BlockType.TableCell);
};
var getBoundingClientRect = function (editorElem) {
    if ((0, EditorTypes_1.isHTMLElement)(editorElem)) {
        return editorElem.getBoundingClientRect();
    }
    else {
        if (!!editorElem.current) {
            return editorElem.current.getBoundingClientRect();
        }
        else {
            return null;
        }
    }
};
var MainEditorToolbarButton = (0, mobx_react_1.observer)(function (_a) {
    var button = _a.button, contextualStylesShowing = _a.contextualStylesShowing, onContextualStylesShowingChange = _a.onContextualStylesShowingChange, onToolbarEvent = _a.onToolbarEvent, editor = _a.editor;
    var onMouseDown = function (event) {
        event.preventDefault();
        if (!(0, EventUtils_1.isPrimaryButton)(event)) {
            return;
        }
        var eventData = lodash_1.default.extend({ button: button.type }, button.data);
        if (button.slateButton) {
            onToolbarEvent(eventData);
        }
        else {
            (0, mobx_1.runInAction)(function () {
                var newState = button.action &&
                    button.action({
                        contextualStylesShowing: contextualStylesShowing,
                    });
                onContextualStylesShowingChange(newState.contextualStylesShowing);
            });
        }
    };
    var viewState = {
        contextualStylesShowing: contextualStylesShowing,
    };
    return (react_1.default.createElement("span", { className: "editor-main-toolbar__button center", "data-active": button.isActive(editor, viewState), onMouseDown: onMouseDown }, button.content));
});
